import { handleActions } from 'redux-actions';
import PrivateModel from './type';
import actionTypes from './action-types';
import { formatTreeToValues, getLeafValue } from './utils';
import { PredictionThresholdVo } from '@/service/swet/models';

const initialState: PrivateModel = {
    sampleList: [],
    positiveList: [],
    negativeList: [],
    featureTree: [],
    flattenLeafTree: [],
    taskStatus: {} as { creatable: boolean } & PredictionThresholdVo,
};

export default handleActions(
    {
        [actionTypes.PRIVATE_MODEL.GET_SAMPLE_LIST_SUCCESS]: (
            state,
            { payload }: { payload: PrivateModel },
        ) => {
            const { sampleList } = payload;
            return {
                ...state,
                sampleList,
                positiveList:
                    sampleList
                        .filter((item) => item.sampleType === 1)
                        ?.map((item) => ({
                            id: String(item.id),
                            name: item.name,
                            count: item.coverNum,
                            disabled: +item.coverNum <= 0,
                            rawData: item,
                        })) || [],
                negativeList:
                    sampleList
                        .filter((item) => item.sampleType === 0)
                        ?.map((item) => ({
                            id: String(item.id),
                            name: item.name,
                            count: item.coverNum,
                            disabled: +item.coverNum <= 0,
                            rawData: item,
                        })) || [],
            };
        },
        [actionTypes.PRIVATE_MODEL.GET_FEATURE_TREE_SUCCESS]: (state, { payload }) => {
            const { featureTree } = payload;
            const oriOption = formatTreeToValues(featureTree ?? []);
            const flattenLeaf = getLeafValue(oriOption);

            return {
                ...state,
                featureTree: payload.featureTree,
                flattenLeafTree: flattenLeaf,
            };
        },
        [actionTypes.PRIVATE_MODEL.GET_PREDICT_THRESHOLD_SUCCESS]: (state, { payload }) => {
            return {
                ...state,
                taskStatus: payload.taskStatus,
            };
        },
    },
    initialState,
);
